import { useFeaturedProducts } from "@/hooks/queries";
import ProductCard from "@/components/products/ProductCard";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

const FeaturedProducts = () => {
  const { data: products = [], isLoading } = useFeaturedProducts(12);

  const featured = products.filter((p) => p.tags?.includes("Bestseller") || p.tags?.includes("Premium")).slice(0, 4);
  const deals = products.filter((p) => p.originalPrice && p.originalPrice > p.price).slice(0, 4);
  const bestsellers = featured.length > 0 ? featured : products.slice(0, 4);
  const todayDeals = deals.length > 0 ? deals : products.filter((p) => p.originalPrice).slice(0, 4);

  if (isLoading) {
    return (
      <section className="py-14 bg-secondary/30">
        <div className="container mx-auto px-4 grid grid-cols-2 md:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="aspect-square rounded-2xl" />
          ))}
        </div>
      </section>
    );
  }

  if (products.length === 0) return null;

  return (
    <section className="py-14 bg-secondary/30">
      <div className="container mx-auto px-4">
        <div className="mb-12">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold">🔥 Bestsellers</h2>
              <p className="text-muted-foreground text-sm mt-1">Most loved by our customers</p>
            </div>
            <Link
              to="/products"
              className="text-sm font-semibold text-primary flex items-center gap-1 hover:gap-2 transition-all"
            >
              View All <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {bestsellers.map((product, i) => (
              <ProductCard key={product.id} product={product} index={i} />
            ))}
          </div>
        </div>

        {todayDeals.length > 0 && (
          <div>
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold">💰 Today's Deals</h2>
                <p className="text-muted-foreground text-sm mt-1">Save big on top picks</p>
              </div>
              <Link
                to="/products"
                className="text-sm font-semibold text-primary flex items-center gap-1 hover:gap-2 transition-all"
              >
                View All <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {todayDeals.map((product, i) => (
                <ProductCard key={product.id} product={product} index={i} />
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default FeaturedProducts;
